import { StyleSheet, View } from "react-native";

import { useThemedStyles, type ThemeColors } from "~/styles/theme";

export function Divider() {
  const stylesheet = useThemedStyles(makeStyles);
  return <View style={stylesheet.divider} />;
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    divider: {
      flex: 1,
      height: StyleSheet.hairlineWidth,
      backgroundColor: colors.border,
    },
  });
